import { createPortal } from 'react-dom';

const Portal = ({ children }) => createPortal(children, document.body, 'portal-root');

export default Portal;
